//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

//* Assets Imports
import constructionWorkersImg from "assets/static/landing/construction_workers.png";

function OriginSection() {
  return (
    <section
      id="origin-section"
      data-testid="origin-section"
      aria-label="Seção de apresentação da origem e propósito do iGooB"
      className={styles.originSection}
    >
      <Container
        id="origin-container"
        data-testid="origin-container"
        aria-label="Container principal da seção de origem"
        maxWidth="xl"
      >
        <div
          id="origin-grid"
          data-testid="origin-grid"
          aria-label="Grade com imagem de obra e textos explicativos"
          className={styles.originGrid}
        >
          <div
            id="origin-image-wrapper"
            data-testid="origin-image-wrapper"
            aria-label="Imagem de engenheiros de obra analisando plantas"
            className={styles.imageWrapper}
          >
            <ScrollTransition
              id="origin-image-transition"
              data-testid="origin-image-transition"
              aria-label="Animação de entrada da imagem de obra"
              delay={200}
            >
              <img
                id="origin-workers-img"
                data-testid="origin-workers-img"
                aria-label="Engenheiros civis na obra"
                src={constructionWorkersImg}
                alt="Engenheiros analisando plantas na obra"
                className={styles.sectionImage}
              />
            </ScrollTransition>
          </div>

          <div
            id="origin-text-container"
            data-testid="origin-text-container"
            aria-label="Container com a história do iGooB"
            className={styles.textContainer}
          >
            <ScrollTransition
              id="origin-title-transition"
              data-testid="origin-title-transition"
              aria-label="Animação de entrada do título de origem"
            >
              <h2
                id="origin-title"
                data-testid="origin-title"
                aria-label="Título: I GO BUILD = iGooB"
                className={styles.sectionTitle}
              >
                I GO BUILD = <span className={styles.goldHighlight}>iGooB</span>
              </h2>
              <div
                id="origin-divider"
                data-testid="origin-divider"
                aria-label="Linha decorativa amarela"
                className={styles.divider}
              />
            </ScrollTransition>

            <ScrollTransition
              id="origin-subtitle-transition"
              data-testid="origin-subtitle-transition"
              aria-label="Animação de entrada do subtítulo"
              delay={200}
            >
              <h3
                id="origin-subtitle"
                data-testid="origin-subtitle"
                aria-label="Subtítulo: Do campo para o app"
                className={styles.subtitle}
              >
                Do campo para o app
              </h3>
            </ScrollTransition>

            <ScrollTransition
              id="origin-desc-transition"
              data-testid="origin-desc-transition"
              aria-label="Animação de entrada da descrição da história"
              delay={350}
            >
              <p
                id="origin-desc-1"
                data-testid="origin-desc-1"
                aria-label="O iGooB surgiu em 2020 durante o gerenciamento de obras durante a pandemia."
                className={styles.descText}
              >
                O iGooB surgiu em 2020 durante o gerenciamento de{" "}
                <span className={styles.goldHighlight}>
                  obras durante a pandemia.
                </span>
              </p>

              <p
                id="origin-desc-2"
                data-testid="origin-desc-2"
                aria-label="Identificamos o caos na comunicação entre Obra x Escritório x Gestor e criamos a solução para unificar esse fluxo de forma inteligente."
                className={styles.descText}
              >
                Identificamos o caos na comunicação entre{" "}
                <span className={styles.goldHighlight}>
                  Obra x Escritório x Gestor
                </span>{" "}
                e criamos a solução para unificar esse fluxo de forma inteligente.
              </p>
            </ScrollTransition>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default OriginSection;
